export enum Sections {
  HOME = 'home',
  HOME_PRODUCTS = 'home_products',
  COMMUNITY = 'community',
  CONTENT_CONSUMER = 'content_consumer',
  CERTIFICATE = 'certificate_consumer'
}
